import { render } from "./ProfessionalProjects.vue?vue&type=template&id=af7cd7bc&scoped=true"
import script from "./ProfessionalProjects.vue?vue&type=script&lang=js"
export * from "./ProfessionalProjects.vue?vue&type=script&lang=js"

import "./ProfessionalProjects.vue?vue&type=style&index=0&id=af7cd7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7cd7bc"]])

export default __exports__